import { Component } from '@angular/core';

import { ConfigureService } from '@app/configure/services/configure.service';
import { ModalService } from '@app/core/services/modal.service';

import { PartExchangeVehicleInfo } from '@app/configure/models/part-exchange-vehicle-info.model';
import { ModalAction } from '@app/core/models/modal-action.model';
import { Modal } from '@app/core/models/modal.model';

@Component({
	selector: 'cng-part-exchange-valuation-modal',
	templateUrl: './part-exchange-valuation.component.html',
	styleUrls: ['./part-exchange-valuation.component.less'],
})
export class ConfigurePartExchangeValuationModalComponent {
	part_exchange: any = {};
	reserve_enabled: boolean = this.configure_service.isStepDealerEnabled('reserve');
	step_mode: string = this.configure_service.getStepMode();
	valuation: any;
	vehicle_info: PartExchangeVehicleInfo;

	constructor(private modal_service: ModalService, private configure_service: ConfigureService) {
		this.constructModal();
	}

	constructModal(): void {
		this.valuation = this.modal_service.data.valuation;
		this.part_exchange = this.modal_service.data.part_exchange;
		this.setVehicleInfo();
		this.modal_service.setConfig(
			new Modal({
				name: 'part_exchange_valuation_modal',
				title: 'Your Valuation',
				canDismissWithOverlay: false,
				actions: this.getModalActions(),
			})
		);

		this.configure_service.track('modal.open', { modal: 'part-exchange-valuation' }).subscribe();
	}

	getModalActions(): ModalAction[] {
		const actions: ModalAction[] = [
			new ModalAction({
				id: 'arrange_callback',
				name: 'Arrange Callback',
				large: true,
				click: () => {
					this.modal_service.show(['configure/callback']);
				},
			}),
		];

		if (this.step_mode === 'full') {
			actions.push(
				new ModalAction({
					id: 'continue',
					name: 'Continue',
					bias: 'positive',
					large: true,
					click: () => {
						this.modal_service.close().then(() => {
							this.configure_service.navigateToStep('customise_review');
						});
					},
				})
			);
		}

		if (this.step_mode === 'part_exchange' && this.reserve_enabled) {
			actions.push(
				new ModalAction({
					id: 'reserve',
					name: 'Reserve Now',
					bias: 'positive',
					large: true,
					click: () => {
						this.modal_service.close().then(() => {
							if (
								this.step_mode === 'part_exchange' &&
								this.configure_service.isStepDealerEnabled('reserve')
							) {
								this.configure_service.enableStep('reserve');
								this.configure_service.navigateToStep('reserve');
							}
						});
					},
				})
			);
		}

		return actions;
	}

	private setVehicleInfo(): void {
		const defaults: any = { vehicle: { make: '', model: '', edition: '' } };

		const { make, model, edition }: any = (this.part_exchange || defaults).vehicle || defaults.vehicle;
		const { registration = '' }: any = (this.part_exchange || { registration: '' }).registration;

		this.vehicle_info = {
			make,
			model,
			edition,
			registration,
		};
	}
}
